import { useQuery } from "@tanstack/react-query";
import { leaveService } from "../../api/leaveService";
import { getEmployeeId } from "../../utils/session";
import { MY_LEAVE_REQUESTS_KEY } from "./leaveUtils";

const PENDING_FILTERS = { status: "pending" };

// Number of my leave requests waiting for approval (sidebar badge).
export const usePendingLeaveCount = () => {
  const query = useQuery({
    queryKey: [MY_LEAVE_REQUESTS_KEY, PENDING_FILTERS],
    queryFn: () => leaveService.getMyRequests(PENDING_FILTERS),
    enabled: !!getEmployeeId(),
    staleTime: 60 * 1000,
    retry: false,
  });

  return Array.isArray(query.data) ? query.data.length : 0;
};
